import React from "react";

export default function SSBFiltersBar({ children, columns = 4 }) {
  return (
    <div
      style={{
        background: "#FFFFFF",
        border: "1px solid #E7ECF3",
        borderRadius: 16,
        padding: 12,
        boxShadow: "0 10px 30px rgba(16,24,40,0.06)",
        marginBottom: 12,
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: 10,
        alignItems: "end",
      }}
    >
      {children}
    </div>
  );
}